import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import PropTypes from 'prop-types';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import { Button, Grid, 
         Paper, Switch, Tooltip, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

import AppBindStyles from '../../AppBindStyles';
import SavingSpinner from '../ui/SavingSpinner';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import AskForCCMutation from './AskForCCMutation'

import classNames from 'classnames';

const abEnvironment = new AbEnvironment();
const StepCCQuery = graphql`
query StepCCQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountName
    askForCc
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left',
    // maxWidth: 980
  },
  button: {
    width: 52,
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class StepCC extends React.Component {
  
  state = {
    requestCC: null,
    savedRequestCC: null
  }

  isBackDisabled() {
    if (this.props.activeStep === 0) {
      return true;
    }

    return false;
  }

  isNextDisabled() {
    return false;
  }

  handleNext() {
    //cannot validate since user not logged in or not trying to add new.
    this.props.handleNext();
  }

  render() {
    const { logError } = this.props.auth;
    const classes = this.props.classes;

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    }

    let acctId = this.props.customer.accountId;

    let ccDescription = "Request credit card";
    let ccTooltip = "You can ask your customer to securely store a credit card in AppBind to pay for subscriptions. If they do, you'll be able to use the AppBind chrome extension to put your customer's card on file to pay for subscriptions.";
    // let ccDetail = "Ask your customer to store a credit card in AppBind to pay for subscriptions.";
    let ccDetail = "You can use your customer’s credit card to pay for subscriptions from the ";
    // You can use your customer’s credit card to pay for subscriptions from the <a target=_blank>AppBind Chrome Extension</a>.

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={StepCCQuery}
        variables={{accountId: acctId}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {
            let theAccount = props.accountTByAccountId;
            let theRequestCC = theAccount.askForCc;
            if (this.state.requestCC != null) {
              theRequestCC = this.state.requestCC;
            }

            if (!displayOnly) {
              return (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Grid container spacing={0}>
                            <Grid item>
                              <Typography align="left" variant="h6">{ccDescription}</Typography>
                            </Grid>                  
                            <Grid item>
                              <Tooltip placement='bottom' title={ccTooltip}>
                                <HelpOutline fontSize="small" style={{verticalAlign: "-32%", marginLeft: '4px'}}/>
                              </Tooltip>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid container alignItems="center" spacing={0}>
                                <Grid item><Typography align="left" variant="body2">{ccDetail}&nbsp;</Typography></Grid>
                                <Grid item><a target="_blank" rel="noopener noreferrer" href="https://chromewebstore.google.com/detail/appbind-subscription-mana/kdfgpmhkppddpmffbclkimffhlbgcobe?pli=1"><Typography variant="body2">AppBind Chrome Extension</Typography></a></Grid>
                                <Grid item><Typography align="left" variant="body2">.</Typography></Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container justifyContent="flex-start" alignItems="center" spacing={2}>
                            <Grid item>
                              <Typography variant="body1" style={AppBindStyles.boldLabel}>Ask for credit card</Typography>
                            </Grid>
                            <Grid item>
                              <Switch checked={theRequestCC === 1} 
                                      onChange={(e, checked) => {
                                        if (checked) {
                                          this.setState({requestCC: 1});
                                        } else {
                                          this.setState({requestCC: 0});
                                        }
                                      }}
                                      color="primary"
                              />
                            </Grid>
                          </Grid>
                        </Grid>  
                      </Grid>
                    </Paper>
                  </Grid>

                  {this.props.activeStep === this.props.assignedStep &&
                  <Grid item xs={12}>
                    <Button
                      disabled={this.isBackDisabled()}
                      color="primary" variant="outlined"
                      onClick={() => { this.updateAccountAskForCC(theAccount, "back");}}
                      style={AppBindStyles.bottomButton}>
                      Back
                    </Button>

                    {this.state.saveStatus !== 'saving' &&
                    <Button
                      color="primary" variant="contained"
                      disabled={this.isNextDisabled()}
                      onClick={() => { this.updateAccountAskForCC(theAccount, "next");}}
                      style={AppBindStyles.bottomButton}>
                        Next
                    </Button>
                    }
                    {this.state.saveStatus === 'saving' &&
                      <Button
                        color="primary" variant="contained"
                        style={AppBindStyles.bottomButton}>
                          <SavingSpinner/>
                      </Button>
                    }
                  </Grid>} 
                </Grid>
              );
            } else {
              //display only
              let ccDescription = "Do not ask for credit card.";
              if (this.state.requestCC === 1) {
                ccDescription = "Ask for credit card.";
              }
              return (
                <Grid container >
                  <Grid item xs={12}>
                    <Typography variant="body1" style={AppBindStyles.boldLabel}>{ccDescription}</Typography>
                  </Grid>
                </Grid>
              );
            }
          }
          if (!displayOnly) {
            return <div><LoadingSpinner/></div>
          }  
        }}
      />
    );
  }

  updateAccountAskForCC(theAccount, nextStep) {
    /*
     * Make sure that there is something to do
     */
    let savedValue = theAccount.askForCc;
    if (this.state.savedRequestCC != null) {
      savedValue = this.state.savedRequestCC;
    }

    if (this.state.requestCC == null || this.state.requestCC === savedValue) {
      if (nextStep === "next") {
        this.props.handleNext();
      } else {
        this.props.handleBack();
      }
      return;
    }

    AskForCCMutation.commit(theAccount.accountId, this.state.requestCC)
    .then(response => {
      this.setState({savedRequestCC: this.state.requestCC});
      if (nextStep === 'next') {
        this.props.handleNext(false);
      } else {
        this.props.handleBack();
      }
    })
    .catch(error => {
      //
    });
  }
}

StepCC.propTypes = {
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(StepCC);
